import {html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';
import '../icon/index.js';

export const TOOLBAR_ELEMENT_TAG = 'fly-toolbar';

/**
 * Toolbar -- Description here
 */
@customElement(TOOLBAR_ELEMENT_TAG)
export default class Toolbar extends FlywheelComponent {
  static get styles() {
    return [styles];
  }

  render() {
    return html`
      <div class="fly-toolbar">
        <div class="fly-toolbar__search">
          <slot></slot>
        </div>
        <slot name="account"> </slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'fly-toolbar': Toolbar;
  }
}
